import { FC } from 'react'
import { Box, VerticalCenteredRow } from '../../core/Components'
import { StemIcon } from '../../core/icons'
import LoadingAnimation from '../../core/LoadingAnimation'
import { LOOP_LETTERS } from '../loops/InstrumentLoop'

interface STCStemDetailsProps {
  isRemixed: boolean
  trackColor: string
  details: string
  category: string
  loopIndex: number
}
const STCStemDetails: FC<STCStemDetailsProps> = ({
  isRemixed,
  trackColor,
  details,
  category,
  loopIndex
}) => (
  <VerticalCenteredRow css={{ flex: '1' }}>
    {isRemixed ? (
      <Box style={{ width: '25px', marginRight: '25px' }}>
        <StemIcon fill={trackColor} />
      </Box>
    ) : (
      <Box
        style={{
          borderRadius: '50%',
          height: '14px',
          minHeight: '14px',
          width: '14px',
          minWidth: '14px',
          marginRight: '15px',
          backgroundColor: trackColor
        }}
      ></Box>
    )}

    <Box className="ellipsis-overflow" title={details} style={{ marginRight: '12px' }}>
      <Box
        style={{ fontSize: '14px', fontWeight: '700', color: '#141414', lineHeight: '24px', transition: '150ms' }}
        className="ellipsis-overflow"
      >
        <span style={{ marginRight: '8px' }}>{category || <LoadingAnimation small />}</span>
        <span
          style={{
            opacity: '0.6',
            fontWeight: '500;',
            lineHeight: '16px'
          }}
        >
          {details || <LoadingAnimation small />}
        </span>
      </Box>
    </Box>
    {loopIndex >= 0 && (
      <span
        style={{
          fontSize: '14px',
          fontWeight: '500',
          paddingLeft: '12px',
          paddingRight: '12px',
          borderLeft: '0.5px solid var(--studio-medium-dark)',
          whiteSpace: 'nowrap'
        }}
      >
        {'Loop ' + LOOP_LETTERS[loopIndex]}
      </span>
    )}
  </VerticalCenteredRow>
)

export default STCStemDetails
